import leetcode from "./portfolio_images/leetcode.png";
import gfg from "./portfolio_images/gfg.png";
import github from "./portfolio_images/github.png";
import linkedin from "./portfolio_images/linkedin.png";
import fitness from "./portfolio_images/fitnessclub.png";
import codingninjas from "./portfolio_images/codingninjas.png";
export const products = [
    {
      id: 1,
      img: fitness,
      link: "https://fitnessclub-by-manas.netlify.app/",
      info : "Fitness APP",
    },
    {
      id: 2,
      img: leetcode,
      link: "https://leetcode.com/Manas2000/",
      info : "Leetcode",
    },
    {
      id: 3,
      img: gfg,
      link: "https://auth.geeksforgeeks.org/user/manassisodia200052/practice",
      info : "GFG",
    },
    {
      id: 4,
      img: linkedin,
      link: "https://www.linkedin.com/in/manas-sisodia-4ab8a5190/",
      info : "LinkedIN",
    },
    {
      id: 5,
      img: github,
      link: "https://github.com/ManasSisodia?tab=repositories",
      info : "Github",
    },
    {
      id: 6,
      img: codingninjas,
      link: "https://www.codingninjas.com/codestudio/profile/f8ce5896-18df-49de-856a-dc84660dd3a8",
      info : "CodeStudio",
    },
  ];